import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["checkbox", "submitButton"]
  static outlets = ["modal"]

  checkboxTargetConnected() {
    this.updateButtonState()
  }

  openDisclosure(event) {
    event.preventDefault()
    event.stopPropagation()
    this.modalOutlet.open()
  }

  stopPropagation(event) {
    event.stopPropagation()
  }

  updateButtonState() {
    if (!this.hasCheckboxTarget || !this.hasSubmitButtonTarget) return

    if (this.checkboxTarget.checked) {
      this.submitButtonTarget.disabled = false
      this.submitButtonTarget.classList.remove('submit-btn-disabled')
      this.submitButtonTarget.classList.add('submit-btn-enabled')
    } else {
      this.submitButtonTarget.disabled = true
      this.submitButtonTarget.classList.remove('submit-btn-enabled')
      this.submitButtonTarget.classList.add('submit-btn-disabled')
    }
  }
}
